import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionPanel,
  AccordionPanelDetails,
  AccordionPanelHeader,
} from '../../Generic/Accordion';
import styles from './Accordian-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { renderSection } from '../../../utils/uiHelper';
import i18nMessages from '../../../constants/messages/pt-BR';

class AccordianTab extends React.Component {
  constructor(props) {
    super(props);
    this.accrodianContainer = this.accrodianContainer.bind(this);
    this.state = {
      expand: [],
      data: props.data,
      collapsible: false,
      width: '',
    };
  }

  componentDidMount() {
    if (typeof window != 'undefined')
      this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    const { data } = this.props;
    const { width, collapsible } = this.state;
    window.addEventListener(i18nMessages.resize, this.handleWindowSizeChange);
    this.handleWindowSizeChange();

    let accordionContent = '';
    if (data.accordianPanelsCollection) {
      accordionContent = data.accordianPanelsCollection.items.map(() => {
        return false;
      });
    } else {
      accordionContent = null;
    }

    let collapsiblebool = collapsible;
    if (width <= 1023) {
      collapsiblebool = true;
    }

    this.setState({ expand: accordionContent, collapsible: collapsiblebool });
  }

  handleWindowSizeChange = () => {
    let collapsiblebool = false;
    if (window.innerWidth <= 1023) {
      collapsiblebool = true;
    }
    this.setState({ width: window.innerWidth, collapsible: collapsiblebool });
  };

  handleClick = key => {
    const { expand } = this.state;
    const { data } = this.props;
    let panel = expand;
    panel =
      data.accordianPanelsCollection &&
      data.accordianPanelsCollection.items.map((e, i) => {
        return i == key ? !panel[key] : false;
      });
    this.setState({ expand: panel });
  };

  accrodianContainer = subItem => {
    let widthClass = '';
    
    // Get width class if componentWidth is defined
    if (subItem.componentWidth) {
      widthClass = getWidth(subItem.componentWidth);
    }
    
    if (subItem.__typename === i18nMessages.sectionContainer) {
      return (
        <div key={subItem.sys.id} className={widthClass}>
          {renderSection(subItem)}
        </div>
      );
    }
  };

  countLinkButtonsInNode = node => {
    if (!node) return 0;
    if (Array.isArray(node)) {
      return node.reduce((sum, item) => sum + this.countLinkButtonsInNode(item), 0);
    }
    if (typeof node !== 'object') return 0;

    let total = 0;
    if (node.__typename === i18nMessages.LinkButton) {
      total += 1;
    }

    Object.keys(node).forEach(key => {
      const value = node[key];
      if (!value) return;

      if (key.endsWith('Collection') && value.items) {
        total += this.countLinkButtonsInNode(value.items);
      } else if (Array.isArray(value) || typeof value === 'object') {
        total += this.countLinkButtonsInNode(value);
      }
    });

    return total;
  };

  accordionPanelData = (dataSet, i, datalength) => {
    let accordion_header = [];
    let accordion_detail = [];
    const { data, expand } = this.state;
    let accordionStyle =
      (data.styles && styles[data.styles.trim()]) || styles[data.variant];
    if (styles[data.styles] === undefined) {
      accordionStyle = styles[data.variant];
    }
    const submenuItemCount = this.countLinkButtonsInNode(
      dataSet && dataSet.contentCollection && dataSet.contentCollection.items
    );

    if (!accordion_header.length && dataSet && accordionStyle) {
      accordion_header.push(
        <div className={classNames(styles.accordHeading)}>
          <AccordionPanelHeader
            key={i}
            panelIndex={i}
            isExpanded={expand ? expand[i] : ''}
            handleClick={this.handleClick}
            accordionStyle={accordionStyle}
            accordionStyleName={data.styles ? data.styles : ''}
            submenuItemCount={submenuItemCount}
          >
            {dataSet.titleContentCollection && accordionStyle && (
              <div
                className={classNames(accordionStyle.accordion.panel_head, {
                  'sm:border-b-0': !expand[i] && i === datalength - 1,
                })}
              >
                {dataSet.titleContentCollection.items.map(sectionItem => {
                  return (
                    <div key={sectionItem.id + i}>
                      {renderSection(sectionItem)}
                    </div>
                  );
                })}
              </div>
            )}
          </AccordionPanelHeader>
        </div>
      );
    }
    for (
      let index = 0;
      index < dataSet.contentCollection.items.length;
      index++
    ) {
      accordion_detail.push(
        this.accrodianContainer(dataSet.contentCollection.items[index])
      );
    }
    return (
      <AccordionPanel key={i} accordionStyle={accordionStyle}>
        {accordion_header}
        <AccordionPanelDetails
          accordionStyle={accordionStyle}
          smartphoneWidth={1023}
          isExpanded={expand ? expand[i] : ''}
        >
          {accordion_detail}
        </AccordionPanelDetails>
      </AccordionPanel>
    );
  };

  render() {
    const { data } = this.state;
    let accordionLength = data.accordianPanelsCollection.items.length;
    return (
      <Accordion className={classNames(styles.accordian.panel)}>
        {data.accordianPanelsCollection
          ? data.accordianPanelsCollection.items.map(
              (accordionpanels, index) => {
                if (accordionpanels) {
                  return this.accordionPanelData(
                    accordionpanels,
                    index,
                    accordionLength
                  );
                } else {
                  return null;
                }
              }
            )
          : ''}
      </Accordion>
    );
  }
}
AccordianTab.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
};
// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const AccordianTab = ({prop = val, data = null }) =>
export default AccordianTab;
